import React, { useEffect } from 'react';

import { useTimer } from 'react-timer-hook';

import styles from './Timer.module.scss';

interface KbaTimerProps {
  onExpire: () => void;
  stopTimer?: boolean;
  expirySeconds: number;
}

const Timer = ({ stopTimer = false, onExpire, expirySeconds }: KbaTimerProps) => {
  const expiryTimestamp = new Date();

  expiryTimestamp.setSeconds(expiryTimestamp.getSeconds() + expirySeconds);

  const { seconds, minutes, pause } = useTimer({
    expiryTimestamp: expiryTimestamp,
    autoStart: true,
    onExpire: onExpire,
  });

  useEffect(() => {
    if (stopTimer) {
      pause();
    }
  }, [stopTimer]);

  if (minutes >= 2) {
    return <></>;
  }

  const minutesText = `0${minutes}`;
  const secondsText = seconds >= 10 ? seconds : `0${seconds}`;

  return (
    <div className={styles.block}>
      <p>Remaining time: </p>
      <div className={styles.last_dial}>
        {minutesText}:{secondsText}
      </div>
    </div>
  );
};

export default Timer;
